module.exports = __webpack_public_path__ + "img/back.8da88351.png";